
import { toAbsoluteApiUrl } from '../../../../../helpers/http-client';

export const getFollowAuthorAvatar = (author) => {
    const avatar = String(author?.photoUrl || author?.avatar || '').trim();
    return toAbsoluteApiUrl(avatar);
};
